import { configureStore } from '@reduxjs/toolkit';
import translationReducer from '../../../../common/lib/redux/slices/translationSlice';

export const store = configureStore({
  reducer: {
    translations: translationReducer,
  },
});

export type Maas360State = ReturnType<typeof store.getState>;
export type Maas360Dispatch = typeof store.dispatch;

export default store;
